import { Loader, Table } from '@mantine/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatCurrency, pushDataLayer } from '../utils/helpers';
import PrimaryButton from '../components/PrimaryButton';
import GreenCheckIcon from '../icons/GreenCheckIcon';
import RestrictedIcon from '../icons/RestrictedIcon';
import RedCrossIcon from '../icons/RedCrossIcon';
import { isBupa } from '../utils/form/helpers';
import {
  setApplyDetails,
  setApplyStep,
  setErrors,
} from '../features/FormRegistration';
import { useLeadsObject } from '../hooks/payment/useLeadsObject';
import axiosRequest from '../utils/axiosConfig';
import { toast } from 'react-toastify';

function ProductComparison() {
  const { compareProducts, formData } = useSelector(
    (state: any) => state.formRegistration,
  );
  const { isMobileView, isDesktopView } = useSelector(
    (state: any) => state.viewport,
  );

  const product1 = compareProducts[0];
  const product2 = compareProducts[1];
  const product3 = compareProducts[2];
  const product4 = compareProducts[3];

  const product1HospitalBenefits = product1.benefits.filter(
    (benefit: any) => benefit.benefit_type === 'hospital',
  );
  const product1ExtraBenefits = product1.benefits.filter( 
    (benefit: any) => benefit.benefit_type === 'extra',
  );
  const product2HospitalBenefits = product2.benefits.filter(
    (benefit: any) => benefit.benefit_type === 'hospital',
  );
  const product2ExtraBenefits = product2.benefits.filter(
    (benefit: any) => benefit.benefit_type === 'extra',
  );

  const product3HospitalBenefits = product3?.benefits.filter(
    (benefit: any) => benefit.benefit_type === 'hospital',
  );
  const product3ExtraBenefits = product3?.benefits.filter(
    (benefit: any) => benefit.benefit_type === 'extra',
  );
  const product4HospitalBenefits = product4?.benefits.filter(
    (benefit: any) => benefit.benefit_type === 'hospital',
  );
  const product4ExtraBenefits = product4?.benefits.filter(
    (benefit: any) => benefit.benefit_type === 'extra',
  );

  const dispatch = useDispatch();
  const leadObject = useLeadsObject();

  const [isLoading, setIsLoading] = React.useState(false);

  if (isMobileView) {
    return (
      <Table withColumnBorders className="!w-full">
        {' '}
        <Table.Tr>
          <Table.Th></Table.Th>
          <Table.Th>
            <div className="flex flex-col justify-start w-full h-full">
              <div className="h-[50px]">
                <img src={product1.coverImage} className="h-[30px]" />
              </div>
              <span className="text-[12px] font-[500] h-[100px]">
                {product1.coverTitle}
              </span>
              <span className="text-[12px] font-normal">
                <strong>
                  {formatCurrency(
                    Number(
                      `${product1.coverMainPrice}.${product1.coverMainPriceDecimal}`,
                    ),
                  )}
                </strong>{' '}
                {formData.paymentFrequency}
              </span>{' '}
              {isLoading ? (
                <Loader />
              ) : (
                <PrimaryButton
                  text="Apply"
                  classNames="!h-[30px]"
                  onClick={async () => {
                    pushDataLayer('funnel_health_fund_chosen', {
                      health_fund_name: product1.healthFundName,
                      health_fund_product: product1.coverTitle,
                    });

                    if (formData.healthFund.split('.')[0] == 0) {
                      if (isBupa(product1.healthFundId)) {
                        dispatch(setApplyStep(-1));
                      }
                      const newLeadObject = {
                        ...leadObject,
                        general_details: {
                          ...leadObject.general_details,
                          product_id: product1.productId,
                        },
                      };

                      axiosRequest
                        .post('/leads', { ...newLeadObject })
                        .then((res) => {})
                        .catch((err) => {
                          console.log(err);
                        });

                      dispatch(
                        setApplyDetails({
                          ...product1,
                        }),
                      );
                      return;
                    }
                    setIsLoading(true);
                    let partnerRelatedHealthFund: any = null;

                    if (formData.partnerHealthFund) {
                      partnerRelatedHealthFund = Number.parseInt(
                        formData.partnerHealthFund.split('.')[0],
                      );
                    }

                    const sellablePayload: any = {
                      customer_related_fund_id: Number.parseInt(
                        formData.healthFund.split('.')[0],
                      ),
                      health_fund_id: product1.healthFundId,
                    };

                    if (partnerRelatedHealthFund) {
                      sellablePayload.partner_related_fund_id =
                        partnerRelatedHealthFund;
                    }
                    try {
                      const sellableResult = await axiosRequest.post(
                        '/sellable',
                        sellablePayload,
                      );
                      setIsLoading(false);
                      if (!sellableResult.data.data[0]) {
                        toast.error(
                          'Unfortunately combining these two funds is not possible. Please contact your health fund directly.',
                        );
                        return;
                      }

                      if (formData.healthFund == product1.healthFundId) {
                        toast.error(
                          'Unfortunately as an existing customer of this fund we are not able to provide online sign up. Please contact your health fund directly.',
                        );
                        return;
                      }

                      dispatch(setErrors({}));
                      if (isBupa(product1.healthFundId)) {
                        dispatch(setApplyStep(-1));
                      }
                      const newLeadObject = {
                        ...leadObject,
                        general_details: {
                          ...leadObject.general_details,
                          product_id: product1.productId,
                        },
                      };
                      axiosRequest
                        .post('/leads', { ...newLeadObject })
                        .then((res) => {})
                        .catch((err) => {
                          console.log(err);
                        });

                      dispatch(
                        setApplyDetails({
                          ...product1,
                        }),
                      );
                    } catch (err) {
                      console.log(err);
                      toast.error('Error fetching data');
                    }
                  }}
                />
              )}
            </div>
          </Table.Th>
          <Table.Th>
            <div className="flex flex-col justify-start w-full h-full">
              <div className="h-[50px]">
                <img src={product2.coverImage} className="h-[30px]" />
              </div>
              <span className="text-[12px] font-[500] h-[100px]">
                {product2.coverTitle}
              </span>
              <span className="text-[12px] font-normal ">
                <strong>
                  {formatCurrency(
                    Number(
                      `${product2.coverMainPrice}.${product2.coverMainPriceDecimal}`,
                    ),
                  )}
                </strong>{' '}
                {formData.paymentFrequency}
              </span>{' '}
              {isLoading ? (
                <Loader />
              ) : (
                <PrimaryButton
                  text="Apply"
                  classNames="!h-[30px]"
                  onClick={async () => {
                    pushDataLayer('funnel_health_fund_chosen', {
                      health_fund_name: product2.healthFundName,
                      health_fund_product: product2.coverTitle,
                    });

                    if (formData.healthFund.split('.')[0] == 0) {
                      if (isBupa(product2.healthFundId)) {
                        dispatch(setApplyStep(-1));
                      }
                      const newLeadObject = {
                        ...leadObject,
                        general_details: {
                          ...leadObject.general_details,
                          product_id: product2.productId,
                        },
                      };

                      axiosRequest
                        .post('/leads', { ...newLeadObject })
                        .then((res) => {})
                        .catch((err) => {
                          console.log(err);
                        });

                      dispatch(
                        setApplyDetails({
                          ...product2,
                        }),
                      );
                      return;
                    }
                    setIsLoading(true);
                    let partnerRelatedHealthFund: any = null;

                    if (formData.partnerHealthFund) {
                      partnerRelatedHealthFund = Number.parseInt(
                        formData.partnerHealthFund.split('.')[0],
                      );
                    }

                    const sellablePayload: any = {
                      customer_related_fund_id: Number.parseInt(
                        formData.healthFund.split('.')[0],
                      ),
                      health_fund_id: product2.healthFundId,
                    };

                    if (partnerRelatedHealthFund) {
                      sellablePayload.partner_related_fund_id =
                        partnerRelatedHealthFund;
                    }
                    try {
                      const sellableResult = await axiosRequest.post(
                        '/sellable',
                        sellablePayload,
                      );
                      setIsLoading(false);
                      if (!sellableResult.data.data[0]) {
                        toast.error(
                          'Unfortunately combining these two funds is not possible. Please contact your health fund directly.',
                        );
                        return;
                      }

                      if (formData.healthFund == product2.healthFundId) {
                        toast.error(
                          'Unfortunately as an existing customer of this fund we are not able to provide online sign up. Please contact your health fund directly.',
                        );
                        return;
                      }

                      dispatch(setErrors({}));
                      if (isBupa(product2.healthFundId)) {
                        dispatch(setApplyStep(-1));
                      }
                      const newLeadObject = {
                        ...leadObject,
                        general_details: {
                          ...leadObject.general_details,
                          product_id: product2.productId,
                        },
                      };
                      axiosRequest
                        .post('/leads', { ...newLeadObject })
                        .then((res) => {})
                        .catch((err) => {
                          console.log(err);
                        });

                      dispatch(
                        setApplyDetails({
                          ...product2,
                        }),
                      );
                    } catch (err) {
                      console.log(err);
                      toast.error('Error fetching data');
                    }
                  }}
                />
              )}
            </div>
          </Table.Th>
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <strong>Special Offer</strong>
          </Table.Td>
          <Table.Td>{product1.specialOfferTitle}</Table.Td>
          <Table.Td>{product2.specialOfferTitle}</Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <strong>Excess</strong>
          </Table.Td>
          <Table.Td>{formatCurrency(product1.excess)}</Table.Td>
          <Table.Td>{formatCurrency(product2.excess)}</Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <strong>Co payment</strong>
          </Table.Td>
          <Table.Td>{product1.coPayment}</Table.Td>
          <Table.Td>{product2.coPayment}</Table.Td>
        </Table.Tr>
        <Table.Tr className="border-b-0">
          <Table.Td>
            <strong>Hospital Benefits</strong>
          </Table.Td>
          <Table.Td></Table.Td>
          <Table.Td></Table.Td>
        </Table.Tr>
        {product1HospitalBenefits.map((benefit: any) => (
          <Table.Tr className="border-b-0">
            <Table.Td>{benefit?.benefit_name}</Table.Td>
            <Table.Td>
              {benefit.sis_type === 'Hospital' ? (
                <GreenCheckIcon />
              ) : benefit.sis_type === 'H_RESTRICTION' ? (
                <RestrictedIcon />
              ) : (
                <RedCrossIcon />
              )}
            </Table.Td>
            <Table.Td>
              {product2HospitalBenefits.find(
                (b: any) => b.benefit_name === benefit.benefit_name,
              ).sis_type === 'Hospital' ? (
                <GreenCheckIcon />
              ) : product2HospitalBenefits.find(
                  (b: any) => b.benefit_name === benefit.benefit_name,
                ).sis_type === 'H_RESTRICTION' ? (
                <RestrictedIcon />
              ) : (
                <RedCrossIcon />
              )}
            </Table.Td>
          </Table.Tr>
        ))}
        <Table.Tr className="border-b-0 border-t border-[#dee2e6]">
          <Table.Td>
            <strong>Extra Benefits</strong>
          </Table.Td>
          <Table.Td></Table.Td>
          <Table.Td></Table.Td>
        </Table.Tr>
        {product1ExtraBenefits.map((benefit: any) => (
          <Table.Tr className="border-b-0">
            <Table.Td>{benefit?.benefit_name}</Table.Td>
            <Table.Td>
              {benefit.sis_type === 'Extra' ? (
                <GreenCheckIcon />
              ) : benefit.sis_type === 'E_RESTRICTION' ? (
                <RestrictedIcon />
              ) : (
                <RedCrossIcon />
              )}
            </Table.Td>
            <Table.Td>
              {product2ExtraBenefits.find(
                (b: any) => b.benefit_name === benefit.benefit_name,
              ).sis_type === 'Extra' ? (
                <GreenCheckIcon />
              ) : product2ExtraBenefits.find(
                  (b: any) => b.benefit_name === benefit.benefit_name,
                ).sis_type === 'E_RESTRICTION' ? (
                <RestrictedIcon />
              ) : (
                <RedCrossIcon />
              )}
            </Table.Td>
          </Table.Tr>
        ))}
      </Table>
    );
  }

  if (isDesktopView) {
    return (
      <Table withColumnBorders>
        {' '}
        <Table.Tr>
          <Table.Th className="!w-[20%]"></Table.Th>
          <Table.Th className="!w-[20%]">
            <div className="flex flex-col justify-start w-full h-full">
              <div className="h-[50px]">
                <img src={product1.coverImage} className="h-[30px]" />
              </div>
              <span className="text-[14px] font-bold h-[100px]">
                {product1.coverTitle}
              </span>
              <span className="text-[14px] font-medium  h-[30px]">
                <strong>
                  {formatCurrency(
                    Number(
                      `${product1.coverMainPrice}.${product1.coverMainPriceDecimal}`,
                    ),
                  )}
                </strong>{' '}
                {formData.paymentFrequency}
              </span>{' '}
              {isLoading ? (
                <Loader />
              ) : (
                <PrimaryButton
                  text="Apply"
                  classNames="!h-[40px]"
                  onClick={async () => {
                    pushDataLayer('funnel_health_fund_chosen', {
                      health_fund_name: product1.healthFundName,
                      health_fund_product: product1.coverTitle,
                    });

                    if (formData.healthFund.split('.')[0] == 0) {
                      if (isBupa(product1.healthFundId)) {
                        dispatch(setApplyStep(-1));
                      }
                      const newLeadObject = {
                        ...leadObject,
                        general_details: {
                          ...leadObject.general_details,
                          product_id: product1.productId,
                        },
                      };

                      axiosRequest
                        .post('/leads', { ...newLeadObject })
                        .then((res) => {})
                        .catch((err) => {
                          console.log(err);
                        });

                      dispatch(
                        setApplyDetails({
                          ...product1,
                        }),
                      );
                      return;
                    }
                    setIsLoading(true);
                    let partnerRelatedHealthFund: any = null;

                    if (formData.partnerHealthFund) {
                      partnerRelatedHealthFund = Number.parseInt(
                        formData.partnerHealthFund.split('.')[0],
                      );
                    }

                    const sellablePayload: any = {
                      customer_related_fund_id: Number.parseInt(
                        formData.healthFund.split('.')[0],
                      ),
                      health_fund_id: product1.healthFundId,
                    };

                    if (partnerRelatedHealthFund) {
                      sellablePayload.partner_related_fund_id =
                        partnerRelatedHealthFund;
                    }
                    try {
                      const sellableResult = await axiosRequest.post(
                        '/sellable',
                        sellablePayload,
                      );
                      setIsLoading(false);
                      if (!sellableResult.data.data[0]) {
                        toast.error(
                          'Unfortunately combining these two funds is not possible. Please contact your health fund directly.',
                        );
                        return;
                      }

                      if (formData.healthFund == product1.healthFundId) {
                        toast.error(
                          'Unfortunately as an existing customer of this fund we are not able to provide online sign up. Please contact your health fund directly.',
                        );
                        return;
                      }

                      dispatch(setErrors({}));
                      if (isBupa(product1.healthFundId)) {
                        dispatch(setApplyStep(-1));
                      }
                      const newLeadObject = {
                        ...leadObject,
                        general_details: {
                          ...leadObject.general_details,
                          product_id: product1.productId,
                        },
                      };
                      axiosRequest
                        .post('/leads', { ...newLeadObject })
                        .then((res) => {})
                        .catch((err) => {
                          console.log(err);
                        });

                      dispatch(
                        setApplyDetails({
                          ...product1,
                        }),
                      );
                    } catch (err) {
                      console.log(err);
                      toast.error('Error fetching data');
                    }
                  }}
                />
              )}
            </div>
          </Table.Th>
          <Table.Th className="!w-[20%]">
            <div className="flex flex-col justify-start w-full h-full">
              <div className="h-[50px]">
                <img src={product2.coverImage} className="h-[30px]" />
              </div>
              <span className="text-[14px] font-bold h-[100px]">
                {product2.coverTitle}
              </span>
              <span className="text-[14px] font-medium  h-[30px]">
                <strong>
                  {formatCurrency(
                    Number(
                      `${product2.coverMainPrice}.${product2.coverMainPriceDecimal}`,
                    ),
                  )}
                </strong>{' '}
                {formData.paymentFrequency}
              </span>
              {isLoading ? (
                <Loader />
              ) : (
                <PrimaryButton
                  text="Apply"
                  classNames="!h-[40px]"
                  onClick={async () => {
                    pushDataLayer('funnel_health_fund_chosen', {
                      health_fund_name: product2.healthFundName,
                      health_fund_product: product2.coverTitle,
                    });

                    if (formData.healthFund.split('.')[0] == 0) {
                      if (isBupa(product2.healthFundId)) {
                        dispatch(setApplyStep(-1));
                      }
                      const newLeadObject = {
                        ...leadObject,
                        general_details: {
                          ...leadObject.general_details,
                          product_id: product2.productId,
                        },
                      };

                      axiosRequest
                        .post('/leads', { ...newLeadObject })
                        .then((res) => {})
                        .catch((err) => {
                          console.log(err);
                        });

                      dispatch(
                        setApplyDetails({
                          ...product2,
                        }),
                      );
                      return;
                    }
                    setIsLoading(true);
                    let partnerRelatedHealthFund: any = null;

                    if (formData.partnerHealthFund) {
                      partnerRelatedHealthFund = Number.parseInt(
                        formData.partnerHealthFund.split('.')[0],
                      );
                    }

                    const sellablePayload: any = {
                      customer_related_fund_id: Number.parseInt(
                        formData.healthFund.split('.')[0],
                      ),
                      health_fund_id: product2.healthFundId,
                    };

                    if (partnerRelatedHealthFund) {
                      sellablePayload.partner_related_fund_id =
                        partnerRelatedHealthFund;
                    }
                    try {
                      const sellableResult = await axiosRequest.post(
                        '/sellable',
                        sellablePayload,
                      );
                      setIsLoading(false);
                      if (!sellableResult.data.data[0]) {
                        toast.error(
                          'Unfortunately combining these two funds is not possible. Please contact your health fund directly.',
                        );
                        return;
                      }

                      if (formData.healthFund == product2.healthFundId) {
                        toast.error(
                          'Unfortunately as an existing customer of this fund we are not able to provide online sign up. Please contact your health fund directly.',
                        );
                        return;
                      }

                      dispatch(setErrors({}));
                      if (isBupa(product2.healthFundId)) {
                        dispatch(setApplyStep(-1));
                      }
                      const newLeadObject = {
                        ...leadObject,
                        general_details: {
                          ...leadObject.general_details,
                          product_id: product2.productId,
                        },
                      };
                      axiosRequest
                        .post('/leads', { ...newLeadObject })
                        .then((res) => {})
                        .catch((err) => {
                          console.log(err);
                        });

                      dispatch(
                        setApplyDetails({
                          ...product2,
                        }),
                      );
                    } catch (err) {
                      console.log(err);
                      toast.error('Error fetching data');
                    }
                  }}
                />
              )}
            </div>
          </Table.Th>
          {product3 && (
            <Table.Th className="!w-[20%]">
              <div className="flex flex-col justify-start w-full h-full">
                <div className="h-[50px]">
                  <img src={product3.coverImage} className="h-[30px]" />
                </div>
                <span className="text-[14px] font-bold h-[100px]">
                  {product3.coverTitle}
                </span>
                <span className="text-[14px] font-medium  h-[30px]">
                  <strong>
                    {formatCurrency(
                      Number(
                        `${product3.coverMainPrice}.${product3.coverMainPriceDecimal}`,
                      ),
                    )}
                  </strong>{' '}
                  {formData.paymentFrequency}
                </span>
                {isLoading ? (
                  <Loader />
                ) : (
                  <PrimaryButton
                    text="Apply"
                    classNames="!h-[40px]"
                    onClick={async () => {
                      pushDataLayer('funnel_health_fund_chosen', {
                        health_fund_name: product3.healthFundName,
                        health_fund_product: product3.coverTitle,
                      });

                      if (formData.healthFund.split('.')[0] == 0) {
                        if (isBupa(product3.healthFundId)) {
                          dispatch(setApplyStep(-1));
                        }
                        const newLeadObject = {
                          ...leadObject,
                          general_details: {
                            ...leadObject.general_details,
                            product_id: product3.productId,
                          },
                        };

                        axiosRequest
                          .post('/leads', { ...newLeadObject })
                          .then((res) => {})
                          .catch((err) => {
                            console.log(err);
                          });

                        dispatch(
                          setApplyDetails({
                            ...product3,
                          }),
                        );
                        return;
                      }
                      setIsLoading(true);
                      let partnerRelatedHealthFund: any = null;

                      if (formData.partnerHealthFund) {
                        partnerRelatedHealthFund = Number.parseInt(
                          formData.partnerHealthFund.split('.')[0],
                        );
                      }

                      const sellablePayload: any = {
                        customer_related_fund_id: Number.parseInt(
                          formData.healthFund.split('.')[0],
                        ),
                        health_fund_id: product3.healthFundId,
                      };

                      if (partnerRelatedHealthFund) {
                        sellablePayload.partner_related_fund_id =
                          partnerRelatedHealthFund;
                      }
                      try {
                        const sellableResult = await axiosRequest.post(
                          '/sellable',
                          sellablePayload,
                        );
                        setIsLoading(false);
                        if (!sellableResult.data.data[0]) {
                          toast.error(
                            'Unfortunately combining these two funds is not possible. Please contact your health fund directly.',
                          );
                          return;
                        }

                        if (formData.healthFund == product3.healthFundId) {
                          toast.error(
                            'Unfortunately as an existing customer of this fund we are not able to provide online sign up. Please contact your health fund directly.',
                          );
                          return;
                        }

                        dispatch(setErrors({}));
                        if (isBupa(product3.healthFundId)) {
                          dispatch(setApplyStep(-1));
                        }
                        const newLeadObject = {
                          ...leadObject,
                          general_details: {
                            ...leadObject.general_details,
                            product_id: product3.productId,
                          },
                        };
                        axiosRequest
                          .post('/leads', { ...newLeadObject })
                          .then((res) => {})
                          .catch((err) => {
                            console.log(err);
                          });

                        dispatch(
                          setApplyDetails({
                            ...product3,
                          }),
                        );
                      } catch (err) {
                        console.log(err);
                        toast.error('Error fetching data');
                      }
                    }}
                  />
                )}
              </div>
            </Table.Th>
          )}
          {product4 && (
            <Table.Th className="!w-[20%]">
              <div className="flex flex-col justify-start w-full h-full">
                <div className="h-[50px]">
                  <img src={product4.coverImage} className="h-[30px]" />
                </div>
                <span className="text-[14px] font-bold h-[100px]">
                  {product4.coverTitle}
                </span>
                <span className="text-[14px] font-medium  h-[30px]">
                  <strong>
                    {formatCurrency(
                      Number(
                        `${product4.coverMainPrice}.${product4.coverMainPriceDecimal}`,
                      ),
                    )}
                  </strong>{' '}
                  {formData.paymentFrequency}
                </span>
                {isLoading ? (
                  <Loader />
                ) : (
                  <PrimaryButton
                    text="Apply"
                    classNames="!h-[40px]"
                    onClick={async () => {
                      pushDataLayer('funnel_health_fund_chosen', {
                        health_fund_name: product4.healthFundName,
                        health_fund_product: product4.coverTitle,
                      });

                      if (formData.healthFund.split('.')[0] == 0) {
                        if (isBupa(product4.healthFundId)) {
                          dispatch(setApplyStep(-1));
                        }
                        const newLeadObject = {
                          ...leadObject,
                          general_details: {
                            ...leadObject.general_details,
                            product_id: product4.productId,
                          },
                        };

                        axiosRequest
                          .post('/leads', { ...newLeadObject })
                          .then((res) => {})
                          .catch((err) => {
                            console.log(err);
                          });

                        dispatch(
                          setApplyDetails({
                            ...product4,
                          }),
                        );
                        return;
                      }
                      setIsLoading(true);
                      let partnerRelatedHealthFund: any = null;

                      if (formData.partnerHealthFund) {
                        partnerRelatedHealthFund = Number.parseInt(
                          formData.partnerHealthFund.split('.')[0],
                        );
                      }

                      const sellablePayload: any = {
                        customer_related_fund_id: Number.parseInt(
                          formData.healthFund.split('.')[0],
                        ),
                        health_fund_id: product4.healthFundId,
                      };

                      if (partnerRelatedHealthFund) {
                        sellablePayload.partner_related_fund_id =
                          partnerRelatedHealthFund;
                      }
                      try {
                        const sellableResult = await axiosRequest.post(
                          '/sellable',
                          sellablePayload,
                        );
                        setIsLoading(false);
                        if (!sellableResult.data.data[0]) {
                          toast.error(
                            'Unfortunately combining these two funds is not possible. Please contact your health fund directly.',
                          );
                          return;
                        }

                        if (formData.healthFund == product4.healthFundId) {
                          toast.error(
                            'Unfortunately as an existing customer of this fund we are not able to provide online sign up. Please contact your health fund directly.',
                          );
                          return;
                        }

                        dispatch(setErrors({}));
                        if (isBupa(product4.healthFundId)) {
                          dispatch(setApplyStep(-1));
                        }
                        const newLeadObject = {
                          ...leadObject,
                          general_details: {
                            ...leadObject.general_details,
                            product_id: product4.productId,
                          },
                        };
                        axiosRequest
                          .post('/leads', { ...newLeadObject })
                          .then((res) => {})
                          .catch((err) => {
                            console.log(err);
                          });

                        dispatch(
                          setApplyDetails({
                            ...product4,
                          }),
                        );
                      } catch (err) {
                        console.log(err);
                        toast.error('Error fetching data');
                      }
                    }}
                  />
                )}
              </div>
            </Table.Th>
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <strong>Special Offer</strong>
          </Table.Td>
          <Table.Td>{product1.specialOfferTitle}</Table.Td>
          <Table.Td>{product2.specialOfferTitle}</Table.Td>
          {product3 && <Table.Td>{product3.specialOfferTitle}</Table.Td>}
          {product4 && <Table.Td>{product4.specialOfferTitle}</Table.Td>}{' '}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <strong>Excess</strong>
          </Table.Td>
          <Table.Td>{formatCurrency(product1.excess)}</Table.Td>
          <Table.Td>{formatCurrency(product2.excess)}</Table.Td>
          {product3 && <Table.Td>{formatCurrency(product3.excess)}</Table.Td>}
          {product4 && (
            <Table.Td>{formatCurrency(product4.excess)}</Table.Td>
          )}{' '}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <strong>Co payment</strong>
          </Table.Td>
          <Table.Td>{product1.coPayment}</Table.Td>
          <Table.Td>{product2.coPayment}</Table.Td>
          {product3 && <Table.Td>{product3.coPayment}</Table.Td>}
          {product4 && <Table.Td>{product4.coPayment}</Table.Td>}
        </Table.Tr>
        <Table.Tr className="border-b-0">
          <Table.Td>
            <strong>Hospital Benefits</strong>
          </Table.Td>
          <Table.Td></Table.Td>
          <Table.Td></Table.Td>
          {product3 && <Table.Td></Table.Td>}
          {product4 && <Table.Td></Table.Td>}
        </Table.Tr>
        {product1HospitalBenefits.map((benefit: any) => (
          <Table.Tr className="border-b-0">
            <Table.Td>{benefit?.benefit_name}</Table.Td>
            <Table.Td>
              {benefit.sis_type === 'Hospital' ? (
                <GreenCheckIcon />
              ) : benefit.sis_type === 'H_RESTRICTION' ? (
                <RestrictedIcon />
              ) : (
                <RedCrossIcon />
              )}
            </Table.Td>
            <Table.Td>
              {product2HospitalBenefits.find(
                (b: any) => b.benefit_name === benefit.benefit_name,
              ).sis_type === 'Hospital' ? (
                <GreenCheckIcon />
              ) : product2HospitalBenefits.find(
                  (b: any) => b.benefit_name === benefit.benefit_name,
                ).sis_type === 'H_RESTRICTION' ? (
                <RestrictedIcon />
              ) : (
                <RedCrossIcon />
              )}
            </Table.Td>
            {product3 && (
              <Table.Td>
                {product3HospitalBenefits.find(
                  (b: any) => b.benefit_name === benefit.benefit_name,
                ).sis_type === 'Hospital' ? (
                  <GreenCheckIcon />
                ) : product3HospitalBenefits.find(
                    (b: any) => b.benefit_name === benefit.benefit_name,
                  ).sis_type === 'H_RESTRICTION' ? (
                  <RestrictedIcon />
                ) : (
                  <RedCrossIcon />
                )}
              </Table.Td>
            )}
            {product4 && (
              <Table.Td>
                {product4HospitalBenefits.find(
                  (b: any) => b.benefit_name === benefit.benefit_name,
                ).sis_type === 'Hospital' ? (
                  <GreenCheckIcon />
                ) : product4HospitalBenefits.find(
                    (b: any) => b.benefit_name === benefit.benefit_name,
                  ).sis_type === 'H_RESTRICTION' ? (
                  <RestrictedIcon />
                ) : (
                  <RedCrossIcon />
                )}
              </Table.Td>
            )}
          </Table.Tr>
        ))}
        <Table.Tr className="border-b-0 border-t border-[#dee2e6]">
          <Table.Td>
            <strong>Extra Benefits</strong>
          </Table.Td>
          <Table.Td></Table.Td>
          <Table.Td></Table.Td>
          {product3 && <Table.Td></Table.Td>}
          {product4 && <Table.Td></Table.Td>}
        </Table.Tr>
        {product1ExtraBenefits.map((benefit: any) => (
          <Table.Tr className="border-b-0">
            <Table.Td>{benefit?.benefit_name}</Table.Td>
            <Table.Td>
              {benefit.sis_type === 'Extra' ? (
                <GreenCheckIcon />
              ) : benefit.sis_type === 'E_RESTRICTION' ? (
                <RestrictedIcon />
              ) : (
                <RedCrossIcon />
              )}
            </Table.Td>
            <Table.Td>
              {product2ExtraBenefits.find(
                (b: any) => b.benefit_name === benefit.benefit_name,
              ).sis_type === 'Extra' ? (
                <GreenCheckIcon />
              ) : product2ExtraBenefits.find(
                  (b: any) => b.benefit_name === benefit.benefit_name,
                ).sis_type === 'E_RESTRICTION' ? (
                <RestrictedIcon />
              ) : (
                <RedCrossIcon />
              )}
            </Table.Td>
            {product3 && (
              <Table.Td>
                {product3ExtraBenefits.find(
                  (b: any) => b.benefit_name === benefit.benefit_name,
                ).sis_type === 'Extra' ? (
                  <GreenCheckIcon />
                ) : product3ExtraBenefits.find(
                    (b: any) => b.benefit_name === benefit.benefit_name,
                  ).sis_type === 'E_RESTRICTION' ? (
                  <RestrictedIcon />
                ) : (
                  <RedCrossIcon />
                )}
              </Table.Td>
            )}
            {product4 && (
              <Table.Td>
                {product4ExtraBenefits.find(
                  (b: any) => b.benefit_name === benefit.benefit_name,
                ).sis_type === 'Extra' ? (
                  <GreenCheckIcon />
                ) : product4ExtraBenefits.find(
                    (b: any) => b.benefit_name === benefit.benefit_name,
                  ).sis_type === 'E_RESTRICTION' ? (
                  <RestrictedIcon />
                ) : (
                  <RedCrossIcon />
                )}
              </Table.Td>
            )}
          </Table.Tr>
        ))}
      </Table>
    );
  }

  return null;
}

export default ProductComparison;
